import React, { useState, useContext, useCallback, Fragment } from 'react';
import CbmContext from '../../Context/Cbm/cbmContext';
import './Mileage.css';
import Comment from '../Comment/Comment';
import EmployeeInfo from '../EmployeeInfo/EmployeeInfo';
import Store from '../Store/Store';
import ValidationErrors from '../Utils/ValidationErrors';
import useFormSetup from '../../hooks/useFormSetup';
import { findStoreById } from '../Utils/helperFuncs';

const Mileage = ({ setPayLoad, setFormError, errMsg }) => {
  const cbmContext = useContext(CbmContext);
  const { stores, portalUser, submittedData, errorCode } = cbmContext;

  const [mileages, setMileages] = useState([
    {
      date: '',
      location1: {},
      location2: {},
    },
  ]);
  const [mileageData, setMileageData] = useState({
    employee: {
      employeeNumber: '',
      employeeFirst: '',
      employeeMiddle: '',
      employeeLast: '',
      employeeSecondLast: '',
    },
    mileageDates: mileages,
    comments: '',
    portalUser,
  });

  // Use unified form setup hook
  const {
    validationErrors,
    getArrayFieldError,
    hasArrayFieldError,
    clearArrayItemErrors,
    getFieldError,
  } = useFormSetup({
    formName: 'mileage',
    formData: mileageData,
    setFormData: setMileageData,
    setPayLoad,
    setFormError,
    submittedData,
    errorCode,
  });

  const changeEmpInfo = useCallback((e) => {
    const { name, value } = e.target;
    setMileageData((prev) => ({
      ...prev,
      employee: { ...prev.employee, [name]: value },
    }));
  }, []);

  const updateMileages = useCallback(
    (e, index) => {
      const { name, value } = e.target;
      setMileageData((prev) => {
        const mileageTemp = [...prev.mileageDates];
        if (name === 'location1' || name === 'location2') {
          mileageTemp[index][name] = findStoreById(stores, value);
        } else {
          mileageTemp[index][name] = value;
        }
        return { ...prev, mileageDates: mileageTemp };
      });
    },
    [stores]
  );

  const addMileage = useCallback(() => {
    setMileageData((prev) => {
      const mileageTemp = [
        ...prev.mileageDates,
        { date: '', location1: '', location2: '' },
      ];
      setMileages(mileageTemp);
      return { ...prev, mileageDates: mileageTemp };
    });
  }, []);

  const removeMileage = useCallback(
    (index) => {
      clearArrayItemErrors('mileageDates', index);
      setMileageData((prev) => {
        const newMileageList = prev.mileageDates.filter((_, i) => i !== index);
        setMileages(newMileageList);
        return { ...prev, mileageDates: newMileageList };
      });
    },
    [clearArrayItemErrors]
  );

  const setMileageComments = useCallback((e) => {
    const { value } = e.target;
    setMileageData((prev) => ({ ...prev, comments: value }));
  }, []);

  return (
    <Fragment>
      <div className="heading">
        <h1>Mileage</h1>
      </div>
      {errMsg && (
        <div className="error-message-container">
          <p className="error-message">{errMsg}</p>
          <ValidationErrors errors={validationErrors} />
        </div>
      )}
      <fieldset>
        <legend>Employee Info</legend>
        <EmployeeInfo
          payload={mileageData}
          changeEmpInfo={changeEmpInfo}
          getFieldError={getFieldError}
          errMsg={errMsg}
        />
      </fieldset>
      <fieldset className="mileageDates">
        <legend>Mileage date</legend>
        {mileageData.mileageDates.map((mileageDate, index) => {
          return (
            <Fragment key={'mileage_' + index}>
              <div id={'mileageDateId'} className="mileage-date-container">
                <div
                  className={
                    errMsg && hasArrayFieldError('mileageDates', index, 'date')
                      ? 'mileageDate error'
                      : 'mileageDate'
                  }
                >
                  <div>
                    <label
                      htmlFor={`mileageDate_${index}`}
                      className="required"
                    >
                      Date
                    </label>
                    <input
                      type="date"
                      name="date"
                      id={`mileageDate_${index}`}
                      value={mileageDate.date || ''}
                      onChange={(e) => updateMileages(e, index)}
                    />
                    {errMsg &&
                      getArrayFieldError('mileageDates', index, 'date') && (
                        <span className="error-text">
                          {getArrayFieldError('mileageDates', index, 'date')}
                        </span>
                      )}
                  </div>
                </div>
                <div className="mileage-location">
                  <Store
                    storeId={'location_' + index}
                    storeValue={mileageData.mileageDates[index].location1?.id}
                    storeList={stores}
                    header="location 1"
                    changeStoreInfo={updateMileages}
                    index={index}
                    elementName="location1"
                  />
                  {errMsg &&
                    getArrayFieldError(
                      'mileageDates',
                      index,
                      'location1.id'
                    ) && (
                      <span className="error-text">
                        {getArrayFieldError(
                          'mileageDates',
                          index,
                          'location1.id'
                        )}
                      </span>
                    )}
                </div>
                <div className="mileage-location">
                  <Store
                    storeId={'location2_' + index}
                    storeValue={mileageData.mileageDates[index].location2?.id}
                    storeList={stores}
                    header="Location 2"
                    changeStoreInfo={updateMileages}
                    index={index}
                    elementName="location2"
                  />
                  {errMsg &&
                    getArrayFieldError(
                      'mileageDates',
                      index,
                      'location2.id'
                    ) && (
                      <span className="error-text">
                        {getArrayFieldError(
                          'mileageDates',
                          index,
                          'location2.id'
                        )}
                      </span>
                    )}
                </div>
              </div>
              <div className="mileage-add-remove-btns">
                <div className="add">
                  <button onClick={() => addMileage()}>Add mileage</button>
                </div>
                <div className="remove">
                  <button onClick={() => removeMileage(index)}>
                    {' '}
                    Remove mileage
                  </button>
                </div>
              </div>
            </Fragment>
          );
        })}
      </fieldset>
      <fieldset className="mileageComments">
        <Comment
          commentsId={'mileageCommentsId'}
          payload={mileageData.comments}
          onHandleChange={setMileageComments}
          getFieldError={getFieldError}
          errMsg={errMsg}
        />
      </fieldset>
    </Fragment>
  );
};
// eslint-disable-next-line
Mileage.propTypes = {};

export default Mileage;
